import React from 'react';
import QuoteCard from './QuoteCard';
import QuoteCardSkeleton from './QuoteCardSkeleton';
var QuoteList = function (_a) {
    var group = _a.group, icon = _a.icon, actions = _a.actions, primaryColor = _a.primaryColor, disabledBuyNowBgColor = _a.disabledBuyNowBgColor;
    return (React.createElement("div", { className: "mb-10" },
        React.createElement("div", { className: "flex items-start gap-3 mb-4" },
            React.createElement("div", { className: "w-9 h-9 rounded-lg bg-[#8241f1]/10 flex items-center justify-center shrink-0" }, icon),
            React.createElement("div", null,
                React.createElement("div", { className: "text-lg font-medium text-left" }, group.groupLabel))),
        React.createElement("div", { className: "grid gap-4 grid-cols-[repeat(auto-fill,minmax(380px,1fr))]" }, group.quotes.map(function (quote) {
            if (quote.isDataLoading) {
                // Renders the skeleton directly for quotes still fetching data
                return React.createElement(QuoteCardSkeleton, { key: quote.quoteKey });
            }
            return (React.createElement(QuoteCard, { key: quote.quoteKey, quote: quote, groupLabel: group.groupLabel, actions: actions, primaryColor: primaryColor, disabledBuyNowBgColor: disabledBuyNowBgColor }));
        }))));
};
export default QuoteList;
